export enum ICON {
  CAMERA = "camera",
  CAMERA_SLASH = "camera-slash",
  CAMERA_BROKEN = "camera-broken",
  PICTURE = "picture",
  PICTURE_2 = "picture-2",
  PICTURE_ARROW_DOWN = "picture-arrow-down",
  MOON = "moon",
  SUN = "sun",
  ARROW_UTURN = "arrow-uturn",
  ARROW_2_CIRCLEPATH = "arrow-2-circlepath",
  CHECKMARK_CIRCLE = "checkmark-circle",
  ARROW_LEFT = "arrow-left",
  EXCLAMATION_HEXAGON = "exclamation-hexagon",
  FACE_SAD = "face-sad",
}
